import { Button, InputNumber, Popover } from "antd";
import React, { useState } from "react";
import { useI18n } from "../../../../../i18n";
import { useCurrentPage, usePageNavigation } from "../Page/NavigationProvider";
import * as style from "../../style.less";
import GoToIcn from "../../assets/goTo.svg";
import BookIcn from "../../assets/book.svg";

type GoToPageProps = {
  totalPageNumber: number;
};

export default function GoToPage({ totalPageNumber }: GoToPageProps) {
  const { requestPage } = usePageNavigation();
  const currentPage = useCurrentPage();
  const [pageNumber, setPageNumber] = useState<number | null>(currentPage);
  const [t] = useI18n();
  const i18nKey = "project.existing.index.goToPage";
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      trigger="hover"
      open={isOpen}
      onOpenChange={(open) => {
        if (open) setPageNumber(currentPage);
        setIsOpen(open);
      }}
      placement="bottom"
      className={style.goToPage}
      title={
        <div
          style={{
            fontSize: "1.2em",
            padding: "0.6em 1.2em",
            textAlign: "center",
          }}>
          {t(`${i18nKey}.nav`)}
        </div>
      }
      content={
        <div className={style.popoverGoTo}>
          <InputNumber
            aria-label={t(`${i18nKey}.nav`)}
            size="middle"
            value={pageNumber}
            onChange={(value) => setPageNumber(value === null ? null : Number(value))}
          />
          <span className={style.popoverGoToSpanCount}>/ {totalPageNumber}</span>
          <Button
            onClick={() => {
              if (pageNumber !== null) requestPage(pageNumber);
            }}>
            {t(`${i18nKey}.validation`)} <GoToIcn />
          </Button>
        </div>
      }>
      <Button aria-label={t(`${i18nKey}.nav`)} className={style.bookIcon}>
        <BookIcn />
      </Button>
    </Popover>
  );
}
